import script from "./zs-manage-layout.vue?vue&type=script&setup=true&lang=tsx"
export * from "./zs-manage-layout.vue?vue&type=script&setup=true&lang=tsx"

import "./zs-manage-layout.vue?vue&type=style&index=0&id=888da9d8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-888da9d8"]])

export default __exports__